import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { RideDto } from '@/services/platform/api/model';

interface ActiveRideState {
  publicGuid: string | null;
  ride: RideDto | null;
  setActiveRide: (ride: RideDto) => void;
  updateRide: (ride: RideDto) => void;
  clearActiveRide: () => void;
}

/**
 * Tracks the customer's currently in-progress Range Rover ride across the whole app
 * session — survives navigation away from the driver-info screen (e.g. back to Home)
 * and app relaunch. See `useActiveRideTracking` for the hook that keeps this fresh.
 */
export const useActiveRideStore = create<ActiveRideState>()(
  persist(
    set => ({
      publicGuid: null,
      ride: null,
      setActiveRide: ride => set({ publicGuid: ride.publicGuid, ride }),
      updateRide: ride => set({ ride }),
      clearActiveRide: () => set({ publicGuid: null, ride: null }),
    }),
    {
      name: 'active-ride-storage',
    }
  )
);
